import { useState } from "react";



export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d79vm6hrcamcd36dbobg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="bg-[#f0faf7] pt-28 pb-16 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: "radial-gradient(circle, #00a88220 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_02d38a0c7abdedabc9108d6ccdf7be20_73e4e683.jpg"
            alt="Seattle skyline at golden hour with Lake Union and Space Needle"
            className="w-full h-64 md:h-80 object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-black/40 border border-white/30 mb-5 backdrop-blur-sm">
              <div className="w-1.5 h-1.5 rounded-full bg-[#00e5c8] animate-pulse"></div>
              <span className="text-white text-xs tracking-[0.2em] uppercase font-bold" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.8)" }}>Let&apos;s Build Together</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4" style={{ textShadow: "0 2px 12px rgba(0,0,0,0.7)" }}>
              Three Industries.<br />
              <span className="text-[#00e5c8] drop-shadow-lg">One Bold Vision.</span>
            </h2>
            <p className="text-white text-base max-w-2xl leading-relaxed font-medium" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.9)" }}>
              Next-generation fungi-derived food ingredients that deliver exceptional taste and nutrition, pioneering bio-based cleaning and environmental safety, and science-backed optimized wellness — MDLARK is where biotechnology meets bold business impact.
            </p>
          </div>
        </div>

        {/* Contact form */}
        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl border border-[#0a2a1f]/10 bg-white p-8">
            <h3 className="text-[#0a2a1f] font-bold text-xl mb-2 text-center">Get in Touch — We Respond ASAP</h3>
            <p className="text-[#0a2a1f]/60 text-sm mb-6 text-center">Tell us about your project or partnership idea and we&apos;ll get back to you as soon as possible.</p>

            {submitted ? (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#00a882]/10 border border-[#00a882]/30 mb-4">
                  <i className="ri-check-line text-[#00a882] text-2xl"></i>
                </div>
                <div className="text-[#0a2a1f] font-semibold text-lg mb-2">Message Sent!</div>
                <div className="text-[#0a2a1f]/55 text-sm">Thanks for reaching out. Our team will be in touch shortly.</div>
              </div>
            ) : (
              <form
                data-readdy-form
                id="mdlark-contact"
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      required
                      placeholder="Jane"
                      className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f] placeholder-[#0a2a1f]/30 focus:outline-none focus:border-[#00a882]/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      required
                      placeholder="Smith"
                      className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f] placeholder-[#0a2a1f]/30 focus:outline-none focus:border-[#00a882]/50 transition-colors"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="jane@company.com"
                      className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f] placeholder-[#0a2a1f]/30 focus:outline-none focus:border-[#00a882]/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">Company</label>
                    <input
                      type="text"
                      name="company"
                      placeholder="Acme Corp"
                      className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f] placeholder-[#0a2a1f]/30 focus:outline-none focus:border-[#00a882]/50 transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">Area of Interest</label>
                  <select
                    name="interest"
                    className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f]/70 focus:outline-none focus:border-[#00a882]/50 transition-colors cursor-pointer"
                  >
                    <option value="all">All Technologies</option>
                    <option value="food-tech">Sustainable Food Tech — Prime Roots</option>
                    <option value="industrial">Industrial Biotech — Gemtek</option>
                    <option value="wellness">Enterprise Wellness — Apollo Neuro</option>
                  </select>
                </div>
                <div>
                  <label className="text-[#0a2a1f]/55 text-xs mb-1.5 block">Message</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Tell us about your project, partnership idea, or question..."
                    className="w-full bg-[#f4faf7] border border-[#0a2a1f]/10 rounded-lg px-4 py-2.5 text-sm text-[#0a2a1f] placeholder-[#0a2a1f]/30 focus:outline-none focus:border-[#00a882]/50 transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="whitespace-nowrap w-full py-3 rounded-full bg-[#00a882] text-white font-semibold text-sm hover:bg-[#008f6e] transition-colors cursor-pointer disabled:opacity-60"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

